import script from "./FeedbackDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackDetails.vue?vue&type=script&setup=true&lang=ts"

import "./FeedbackDetails.vue?vue&type=style&index=0&id=08558768&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08558768"]])

export default __exports__